'use client';
import React, { useState, useEffect } from 'react';
import Header from '@/components/Header';
import FooterSection from '@/components/FooterSection';
import MembershipSection from '@/components/MembershipSection';
import CookieConsent from '@/components/CookieConsent';
import { Language } from '@/lib/i18n';
import { useMergedTranslations } from '@/lib/useMergedTranslations';

const STORAGE_KEY = 'ditib_language';

export default function MembershipPage() {
    const [language, setLanguage] = useState<Language>('de');
    const t = useMergedTranslations(language);

    useEffect(() => {
        // Restore language preference from localStorage
        const savedLang = localStorage.getItem(STORAGE_KEY);
        if (savedLang && ['de', 'tr', 'en', 'ar'].includes(savedLang)) {
            setLanguage(savedLang as Language);
        }
    }, []);

    const handleSetLanguage = (lang: Language) => {
        setLanguage(lang);
        localStorage.setItem(STORAGE_KEY, lang);
    };

    useEffect(() => {
        // Handle scroll from URL parameter
        const params = new URLSearchParams(window.location.search);
        const scrollTo = params.get('scroll');
        if (scrollTo) {
            setTimeout(() => {
                const el = document.getElementById(scrollTo);
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 500);
        }
    }, []);

    return (
        <main data-component-id="src\app\membership\page.tsx:42:8" data-component-path="src\app\membership\page.tsx" data-component-line="42" data-component-end-line="55" data-component-file="page.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%2C%22className%22%3A%22font-opensans%22%7D" className="font-opensans">
            <Header data-component-id="src\app\membership\page.tsx:43:12" data-component-path="src\app\membership\page.tsx" data-component-line="43" data-component-end-line="43" data-component-file="page.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" t={t} language={language} setLanguage={handleSetLanguage} />

            {/* Spacer for fixed header */}
            <div data-component-id="src\app\membership\page.tsx:46:12" data-component-path="src\app\membership\page.tsx" data-component-line="46" data-component-end-line="46" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22h-16%20md%3Ah-20%22%7D" className="h-16 md:h-20"></div>

            {/* Membership Form Section */}
            <div data-component-id="src\app\membership\page.tsx:49:12" data-component-path="src\app\membership\page.tsx" data-component-line="49" data-component-end-line="51" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22id%22%3A%22membership-section%22%7D" id="membership-section">
                <MembershipSection data-component-id="src\app\membership\page.tsx:50:16" data-component-path="src\app\membership\page.tsx" data-component-line="50" data-component-end-line="50" data-component-file="page.tsx" data-component-name="MembershipSection" data-component-content="%7B%22elementName%22%3A%22MembershipSection%22%7D" t={t} language={language} />
            </div>

            <FooterSection data-component-id="src\app\membership\page.tsx:53:12" data-component-path="src\app\membership\page.tsx" data-component-line="53" data-component-end-line="53" data-component-file="page.tsx" data-component-name="FooterSection" data-component-content="%7B%22elementName%22%3A%22FooterSection%22%7D" t={t} language={language} />
            <CookieConsent data-component-id="src\app\membership\page.tsx:54:12" data-component-path="src\app\membership\page.tsx" data-component-line="54" data-component-end-line="54" data-component-file="page.tsx" data-component-name="CookieConsent" data-component-content="%7B%22elementName%22%3A%22CookieConsent%22%7D" t={t} language={language} />
        </main>
    );
}
